import React from "react";
import { useState, useEffect } from "react";

import { Route, Switch } from "react-router-dom";
import axios from "axios";
import $ from "jquery";
//Styles
import "../styles/bootstrap.min.css";
import "../styles/fontawesome.css";
import "../styles/bootstrap-rtl.css";
import "../styles/fontiran.css";
import "../styles/style.css";
import "../styles/open-iconic-bootstrap.min.css";

//JavaScript
import "jquery/dist/jquery";
import "bootstrap/dist/js/bootstrap";

//Components
import NoMatch from "./NoMatch";
import PrivateRoute from "./PrivateRoute";
import LoginAdmin from "./LoginAdmin";
import Panel from "./Panel";
import Data from "./Data";
import {
  CircularProgress,
  LinearProgress,
  MuiThemeProvider,
} from "@material-ui/core";
import Price from "./Price";
import Offs from "./Offs";
import Students from "./Students";
import MastersPanel from "./MastersPanel";
import Instruments from "./Instruments";
import ClassesPanel from "./ClassesPanel";
import Pays from "./Pays";
import RegisterClass from "./RegisterClass";
import Pay from "./Pay";
import createPalette from "@material-ui/core/styles/createPalette";
import createTypography from "@material-ui/core/styles/createTypography";
import createTheme from "@material-ui/core/styles/createTheme";
import { SnackbarProvider, withSnackbar } from "notistack";
import Button from "@material-ui/core/Button";
import {
  NextUIProvider,
  createTheme as ct,
  Text,
  Loading,
} from "@nextui-org/react";
import {
  ThemeProvider,
  createTheme as createTheme2,
} from "@mui/material/styles";

import useDarkMode from "use-dark-mode";

const lighttheme1 = (() => {
  const palette = createPalette({
    type: "light",
    rtl: true,
    primary: {
      main: "#0072F5",
    },
    secondary: {
      main: "#7828C8",
    },

    error: {
      main: "#F31260",
    },
    background: {
      default: "#fff",
    },
  });

  const typography = createTypography(palette, {
    fontFamily: "IRANSans",
    useNextVariants: true,
  });

  return createTheme({
    direction: "rtl",
    palette: palette,
    typography: typography,
  });
})();
const darktheme1 = (() => {
  const palette = createPalette({
    type: "dark",
    rtl: true,
    primary: {
      main: "#0072F5",
    },
    secondary: {
      main: "#7828C8",
    },

    error: {
      main: "#F31260",
    },
    background: {
      default: "#000",
    },
  });

  const typography = createTypography(palette, {
    fontFamily: "IRANSans",
    useNextVariants: true,
  });

  return createTheme({
    direction: "rtl",
    palette: palette,
    typography: typography,
  });
})();

const lightTheme2 = createTheme2({
  direction: "rtl",
  typography: {
    fontFamily: "IRANSans",
    useNextVariants: true,
  },
  palette: {
    mode: "light",
    rtl: true,
    primary: {
      main: "#0072F5",
    },
    secondary: {
      main: "#7828C8",
    },

    error: {
      main: "#F31260",
    },
    background: {
      default: "#000",
    },
  },
});

const darkTheme2 = createTheme2({
  direction: "rtl",
  typography: {
    fontFamily: "IRANSans",
    useNextVariants: true,
  },
  palette: {
    mode: "dark",
    rtl: true,
    primary: {
      main: "#0072F5",
    },
    secondary: {
      main: "#7828C8",
    },

    error: {
      main: "#F31260",
    },
    background: {
      default: "#000",
    },
  },
});

const lightTheme = ct({
  type: "light",
  theme: {
    colors: {}, // optional
    fonts: {
      sans: "IRANSans",
      mono: "IRANSans",
      serif: "IRANSans ",
    },
  },
});

const darkTheme = ct({
  type: "dark",
  theme: {
    colors: {}, // optional
    fonts: {
      sans: "IRANSans",
      mono: "IRANSans",
      serif: "IRANSans ",
    },
  },
});

export default function App(props) {
  const [isAuth, SetIsAuth] = useState(true);
  const [isAuth2, SetIsAuth2] = useState(true);

  const darkMode = useDarkMode(false);
  useEffect(() => {
    let token = localStorage.getItem("token");
    let token2 = localStorage.getItem("admintoken");

    if (token !== null) {
      SetIsAuth(true);
    } else {
      SetIsAuth(false);
    }
    if (token2 !== null) {
      SetIsAuth2(true);
    } else {
      SetIsAuth2(false);
    }

    $(".toast").toast("hide");

    let data = new FormData();
    data.append("token", token2);
    if (token2 !== null) {
      axios
        .post(Data.server + `getToken.php`, data)
        .then((response) => {
          if (response.data.auth === "yes") {
            SetIsAuth2(true);
          }
          if (response.data.auth === "no") {
            SetIsAuth2(false);
            localStorage.removeItem("admintoken");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      SetIsAuth2(false);
      localStorage.removeItem("admintoken");
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("admintoken");
    SetIsAuth2(false);
  };

  const handleLogin = () => {
    SetIsAuth2(true);
  };

  let spinnerid = "waitspinner";
  const notistackRef = React.createRef();
  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };
  return (
    <NextUIProvider theme={darkMode.value ? darkTheme : lightTheme}>
      <MuiThemeProvider theme={darkMode.value ? darktheme1 : lighttheme1}>
        <ThemeProvider theme={darkMode.value ? darkTheme2 : lightTheme2}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            style={{ zIndex: "99999" }}
            ref={notistackRef}
            autoHideDuration={5000}
            action={(key) => (
              <Button
                color={"#bc2727"}
                onClick={onClickDismiss(key)}
                style={{ fontFamily: "IRANSans" }}
              >
                بستن
              </Button>
            )}
          >
            <div className="col-12 p-0">
              <LinearProgress
                className="position-fixed fixed-top invisible mt-0"
                id="progressTop"
                color="secondary"
              />
              <div
                className="modal"
                id="waitspinner"
                tabIndex="-11"
                aria-labelledby={"waitspinnerLabel"}
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-scrollable modal-sm modal-dialog-centered">
                  <div
                    className="modal-content"
                    style={{ borderRadius: "14px" }}
                  >
                    <div className="modal-body">
                      <div className="d-flex justify-content-between">
                        <Text
                          className="my-auto"
                          h4
                          css={{
                            textGradient: "45deg, $blue600 -20%, $pink600 50%",
                          }}
                        >
                          لطفا کمی صبر کنید ...
                        </Text>

                        <Loading size="lg" color="secondary"></Loading>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Switch>
                <PrivateRoute
                  path="/"
                  exact={true}
                  component={Panel}
                  auth={isAuth2}
                  logout={handleLogout.bind(this)}
                />
                <PrivateRoute
                  path="/price"
                  exact={true}
                  component={Price}
                  auth={isAuth2}
                  logout={handleLogout.bind(this)}
                />
                <PrivateRoute
                  path="/offs"
                  exact={true}
                  component={Offs}
                  auth={isAuth2}
                  logout={handleLogout.bind(this)}
                />
                <PrivateRoute
                  path="/students"
                  exact={true}
                  component={Students}
                  auth={isAuth2}
                  logout={handleLogout.bind(this)}
                />
                <PrivateRoute
                  path="/masters"
                  exact={true}
                  component={MastersPanel}
                  auth={isAuth2}
                  logout={handleLogout.bind(this)}
                />
                <PrivateRoute
                  path="/instruments"
                  exact={true}
                  component={Instruments}
                  auth={isAuth2}
                  logout={handleLogout.bind(this)}
                />
                <PrivateRoute
                  path="/classes"
                  exact={true}
                  component={ClassesPanel}
                  auth={isAuth2}
                  logout={handleLogout.bind(this)}
                />
                <PrivateRoute
                  path="/payments"
                  exact={true}
                  component={Pays}
                  auth={isAuth2}
                  logout={handleLogout.bind(this)}
                />
                <PrivateRoute
                  path="/addstudent"
                  exact={true}
                  component={RegisterClass}
                  auth={isAuth2}
                  logout={handleLogout.bind(this)}
                />
                <PrivateRoute
                  path="/pay"
                  exact={true}
                  component={Pay}
                  auth={isAuth2}
                  logout={handleLogout.bind(this)}
                />
                <Route
                  path="/admin_login"
                  render={(props) => (
                    <LoginAdmin
                      {...props}
                      auth={isAuth2}
                      login={handleLogin.bind(this)}
                    />
                  )}
                />
                <Route component={NoMatch} />
              </Switch>
            </div>
          </SnackbarProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    </NextUIProvider>
  );
}
